<template>
    <div class="row mt-3 mb-0">
        <div class="col-md-12 discharges" >
            <h2 class="discharges__title title--1" style="font-size: 19px">
                Discharges
            </h2>
            <div class="row">
                <div class="col-md-12">
                    <table class="table table-responsive table-without-border">
                        <thead class="bg-white">
                            <tr>
                            <th scope="col" style="font-size: 1.2rem !important; width: 20%"></th>
                            <th scope="col" style="font-size: 15px !important; color: #515354">#</th>
                            <th scope="col" style="font-size: 15px !important; color: #515354">Emp/Procedure</th>
                            <th scope="col" style="font-size: 15px !important; color: #515354">Minutes</th>
                            <th scope="col" style="font-size: 15px !important; color: #515354">Daily Minutes</th>
                            <th scope="col" style="font-size: 15px !important; color: #515354">Days/Week</th>
                            <th scope="col" style="font-size: 15px !important; color: #515354">Annual Hours</th>
                            <th scope="col" style="font-size: 15px !important; color: #515354">FTEs</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in discharges_format" :key="index" style="line-height: 0.5">
                                <td v-html="item.name" class="modal-label p-0" style="font-size: 15px !important; color: #515354 !important"/>
                                <td v-for="(field,j) in item.fields" :key="j" class="p-1">
                                <div>
                                    <input 
                                    :placeholder="field['placeholder'] !== undefined ? field.placeholder : ''"
                                    :disabled="field.disabled"
                                    :step="field.step"
                                    :type="field.type" 
                                    :pattern="field.pattern ? field.pattern : ''"
                                    :maxlength="field.maxlength"
                                    style="max-width: 85%; border-bottom: 1px solid #9e9e9e8c !important;"
                                    :min="field.type === 'date' && min_date !== undefined ? min_date : field.minlength !== undefined ? field.minlength : ''"
                                    :max="field.type === 'date' && max_date !== undefined ? max_date : field.maxlength"
                                    :required="field.required"
                                    id="staffing__discharges--input"
                                    v-model="single_object[field.model_name]"
                                    />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div> 
    </div>

</template>

<script>
import Resources        from    './resources'
import FormResources    from    './form_resources'
import 'vuetify/dist/vuetify.min.css'

export default {

    name: 'DischargesForm',

    components: {

    },

    props:[
        'single_object',
    ],

    data() {
        return {
            user:               this.get_user(),
            title_page:         'Staffing Scenario Update',
            rest_api:           `staffing_scenarios/${this.$route.params.id}`,
            table_headers:      Resources.table_headers,
            breadcrumb:         Resources.breadcrumb_update,
            add_btn:            'Add Staffing Scenario',
            single_select:      false,
            table_selection:    [],
            global_index:       '',
            array_options:      {},
            discharges_format:  FormResources.discharges_format,
            scenario_id:        this.$route.params.id,
        }
    },

    watch:{
        async 'ld_case'()
        {
            let number   = Number(this.single_object.ld_case_number)
            let emp_proc = Number(this.single_object.ld_case_emp_proc)
            let minutes  = Number(this.single_object.ld_case_minutes)

            if(number && emp_proc && minutes)
            {
                let daily_minutes =  (minutes * number * emp_proc)
                this.single_object.ld_case_daily_minutes = this.numberStringFormat(daily_minutes, 1)

                let days_week = this.single_object.ld_case_days_week 

                if(daily_minutes && days_week)
                {
                    let annual_hours = ((daily_minutes * days_week * 52)/60)
                    this.single_object.ld_case_annual_hours = this.numberStringFormat(annual_hours, 1)
                  
                    this.single_object.ld_case_ftes = this.numberStringFormat((annual_hours / (this.single_object.fte_hours * 52)),1)
                    
                }
                else
                {
                    this.single_object.ld_case_ftes          = 0
                    this.single_object.ld_case_annual_hours  = 0
                }
            }
            else
            {
                this.single_object.ld_case_daily_minutes = 0
                this.single_object.ld_case_ftes          = 0
                this.single_object.ld_case_annual_hours  = 0
            }
        },

        async 'or_case'()
        {
            let number   = this.single_object.or_case_number
            let emp_proc = this.single_object.or_case_emp_proc
            let minutes  = this.single_object.or_case_minutes

            if(number && emp_proc && minutes)
            {
                let daily_minutes =  (minutes * number * emp_proc)
                this.single_object.or_case_daily_minutes = this.numberStringFormat(daily_minutes, 1)

                let days_week = this.single_object.or_case_days_week 

                if(daily_minutes && days_week)
                {
                    let annual_hours = ((daily_minutes * days_week * 52)/60)
                    this.single_object.or_case_annual_hours = this.numberStringFormat(annual_hours, 1)

                    this.single_object.or_case_ftes = this.numberStringFormat((annual_hours / (this.single_object.fte_hours * 52)) , 1)                  
                }
                else
                {
                    this.single_object.or_case_ftes          = 0
                    this.single_object.or_case_annual_hours  = 0
                }
            }
            else
            {
                this.single_object.or_case_daily_minutes = 0
                this.single_object.or_case_ftes          = 0
                this.single_object.or_case_annual_hours  = 0
            }
        },

        async 'discharge'()
        {
            let number   = this.single_object.discharge_number
            let emp_proc = this.single_object.discharge_emp_proc
            let minutes  = this.single_object.discharge_minutes

            if(number && emp_proc && minutes)
            {
                let daily_minutes =  (minutes * number * emp_proc)
                this.single_object.discharge_daily_minutes = this.numberStringFormat(daily_minutes, 1)

                let days_week = this.single_object.discharge_days_week 

                if(daily_minutes && days_week)
                {
                    let annual_hours = ((daily_minutes * days_week * 52)/60)
                    this.single_object.discharge_annual_hours = this.numberStringFormat(annual_hours, 1)

                    this.single_object.discharge_ftes = this.numberStringFormat((annual_hours / (this.single_object.fte_hours * 52)), 1)
                }
                else
                {
                    this.single_object.discharge_ftes          = 0
                    this.single_object.discharge_annual_hours  = 0
                }
            }
            else
            {
                this.single_object.discharge_daily_minutes = 0
                this.single_object.discharge_ftes          = 0
                this.single_object.discharge_annual_hours  = 0
            }
        },

        async 'cath_lab_between'()
        {
            let number   = this.single_object.cath_lab_between_case_number
            let emp_proc = this.single_object.cath_lab_between_case_emp_proc
            let minutes  = this.single_object.cath_lab_between_case_minutes

            if(number && emp_proc && minutes)
            {
                let daily_minutes =  (minutes * number * emp_proc)
                this.single_object.cath_lab_between_case_daily_minutes = this.numberStringFormat(daily_minutes, 1)

                let days_week = this.single_object.cath_lab_between_case_days_week 

                if(daily_minutes && days_week)
                {
                    let annual_hours = ((daily_minutes * days_week * 52)/60)
                    this.single_object.cath_lab_between_case_annual_hours = this.numberStringFormat(annual_hours, 1)

                    this.single_object.cath_lab_between_case_ftes = this.numberStringFormat((annual_hours / (this.single_object.fte_hours * 52)), 1)
                }
                else
                {
                    this.single_object.cath_lab_between_case_ftes          = 0
                    this.single_object.cath_lab_between_case_annual_hours  = 0
                }
            }
            else
            {
                this.single_object.cath_lab_between_case_daily_minutes = 0
                this.single_object.cath_lab_between_case_ftes          = 0
                this.single_object.cath_lab_between_case_annual_hours  = 0
            }
        },

        async 'triagle_between_case'()
        {
            let number   = this.single_object.triagle_between_case_number
            let emp_proc = this.single_object.triagle_between_case_emp_proc
            let minutes  = this.single_object.triagle_between_case_minutes

            if(number && emp_proc && minutes)
            {
                let daily_minutes =  (minutes * number * emp_proc)
                this.single_object.triagle_between_case_daily_minutes = this.numberStringFormat(daily_minutes, 1)

                let days_week = this.single_object.triagle_between_case_days_week 

                if(daily_minutes && days_week)
                {
                    let annual_hours = ((daily_minutes * days_week * 52)/60)
                    this.single_object.triagle_between_case_annual_hours = this.numberStringFormat(annual_hours, 1)

                    this.single_object.triagle_between_case_ftes = this.numberStringFormat((annual_hours / (this.single_object.fte_hours * 52)), 1)
                }
                else
                {
                    this.single_object.triagle_between_case_ftes          = 0
                    this.single_object.triagle_between_case_annual_hours  = 0
                }
            }
            else
            {
                this.single_object.triagle_between_case_daily_minutes = 0
                this.single_object.triagle_between_case_ftes = 0
                this.single_object.triagle_between_case_annual_hours  = 0
            }
        },

        async 'ed_between_case'()
        {
            let number   = this.single_object.ed_between_case_number
            let emp_proc = this.single_object.ed_between_case_emp_proc
            let minutes  = this.single_object.ed_between_case_minutes

            if(number && emp_proc && minutes)
            {
                let daily_minutes =  (minutes * number * emp_proc)
                this.single_object.ed_between_case_daily_minutes = this.numberStringFormat(daily_minutes, 1)

                let days_week = this.single_object.ed_between_case_days_week 

                if(daily_minutes && days_week)
                {
                    let annual_hours = ((daily_minutes * days_week * 52)/60)
                    this.single_object.ed_between_case_annual_hours = this.numberStringFormat(annual_hours, 1)

                    this.single_object.ed_between_case_ftes = this.numberStringFormat((annual_hours / (this.single_object.fte_hours * 52)), 1)
                }
                else
                {
                    this.single_object.ed_between_case_ftes          = 0
                    this.single_object.ed_between_case_annual_hours  = 0
                }
                
            }
            else
            {
                this.single_object.ed_between_case_daily_minutes = 0
                this.single_object.ed_between_case_ftes          = 0
                this.single_object.ed_between_case_annual_hours  = 0
            }
        },

    },
    computed:{
        ld_case() 
        {
          return `${this.single_object.ld_case_number}|${this.single_object.ld_case_emp_proc}|
          ${this.single_object.ld_case_minutes}|${this.single_object.fte_hours}|${this.single_object.ld_case_days_week}`;
        },
        or_case()
        {
            return `${this.single_object.or_case_number}|${this.single_object.or_case_emp_proc}|${this.single_object.fte_hours}|
          ${this.single_object.or_case_minutes}|${this.single_object.or_case_daily_minutes}|${this.single_object.or_case_days_week}`;
        },
        discharge()
        {
            return `${this.single_object.discharge_number}|${this.single_object.discharge_emp_proc}|${this.single_object.fte_hours}|
          ${this.single_object.discharge_minutes}|${this.single_object.discharge_daily_minutes}|${this.single_object.discharge_days_week}`;
        },
        cath_lab_between()
        {
            return `${this.single_object.cath_lab_between_case_number}|${this.single_object.cath_lab_between_case_emp_proc}|${this.single_object.fte_hours}|
            ${this.single_object.cath_lab_between_case_minutes}|${this.single_object.cath_lab_between_case_daily_minutes}|${this.single_object.cath_lab_between_case_days_week}`;
        },
        triagle_between_case()
        {
            return `${this.single_object.triagle_between_case_number}|${this.single_object.triagle_between_case_emp_proc}|${this.single_object.fte_hours}|
            ${this.single_object.triagle_between_case_minutes}|${this.single_object.triagle_between_case_days_week}`;
        },
        ed_between_case()
        {
            return `${this.single_object.ed_between_case_number}|${this.single_object.ed_between_case_emp_proc}|${this.single_object.fte_hours}|
            ${this.single_object.ed_between_case_minutes}|${this.single_object.ed_between_case_days_week}`;
        },
        
    }
}
</script>
